const routesCommonAuthenticated = {
  routes() {
    return [
      {
        path: "/profile",
        name: "profile",
        component: () => import("./views/common/profile/Profile.vue")
      }
    ];
  }
};

export default routesCommonAuthenticated;
